import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deleteRole = defineEndpoint({
  method: 'DELETE',
  path: '/v1/roles/:roleId',
  params: z.object({ roleId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
